import React from "react";
import vtLogo from "../Assets/Images/VTFullLogo.png";
import { ReactComponent as Instagram } from "../Assets/Svgs/instagram.svg";
import { ReactComponent as Facebook } from "../Assets/Svgs/facebook.svg";
import { ReactComponent as Linkedin } from "../Assets/Svgs/linkedin.svg";
import { ReactComponent as Phone } from "../Assets/Svgs/phone.svg";
import { Link } from "react-router-dom";
const Footer = () => {
  return (
    <div
      style={{
        background: "#350D68",
        padding: "50px ",
        overflowY: "hidden",
      }}
    >
      <div
        style={{ background: "#7C1CFF", borderRadius: "20px", padding: "50px" }}
      >
        <div className="row flex-row">
          {" "}
          <div
            className="col-2"
            style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          >
            <img src={vtLogo} alt="Vidyut" height={"32px"} width={"160px"} />
            <div style={{ color: "#fff", fontSize: "12px" }}>
              2nd Floor, 2nd Building, Hustlehub Techpark, 27th Main Road End,
              HSR Layout Sector 1, Bangalore, Karnataka, India - 560102
            </div>

            <div
              className="d-flex"
              style={{ gap: "20px", alignItems: "center" }}
            >
              <a
                href="https://www.instagram.com/vidyut.tech/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instagram />
              </a>
              <a
                href="https://www.linkedin.com/company/vidyuttech/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Linkedin />
              </a>
              <a
                href="https://www.facebook.com/vidyuttechservices"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Facebook />
              </a>
              <a href="tel:+917027024496">
                <Phone />
              </a>
            </div>
          </div>
          <div className="col-8 d-flex justify-content-center align-items-end">
            <div className="d-flex" style={{ gap: "24px" }}>
              <Link
                to="/terms"
                style={{
                  textDecoration: "none",
                  color: "#fff",
                  fontWeight: "600",
                }}
              >
                Terms & Condition
              </Link>

              <Link
                to="/privacy-policy"
                style={{
                  textDecoration: "none",
                  color: "#fff",
                  fontWeight: "600",
                }}
              >
                Privacy Policy
              </Link>
              <Link
                to="/Grievance-Redressal-Policy"
                style={{
                  textDecoration: "none",
                  color: "#fff",
                  fontWeight: "600",
                }}
              >
                Grievance Redressal
              </Link>
              <a
                href="https://www.vidyuttech.com/withdraw-consent/"
                style={{
                  textDecoration: "none",
                  color: "#fff",
                  fontWeight: "600",
                }}
              >
                Withdraw Consent
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        className="d-flex w-100 justify-content-center"
        style={{ color: "#fff", fontSize: "18px", paddingTop: "50px" }}
      >
        Copyright © <span style={{ fontWeight: "600" }}>Vidyut Tech</span>
      </div>
    </div>
  );
};
export default Footer;
